import type { ComponentProps } from 'react'
import { pageTitleClass, type PageTitleSize } from './classes'

export { pageTitleClass }

/** The page's h1 (`as="h2"` for dialog headings that share the style). */
export function PageTitle({
  size = 'lg',
  as: Tag = 'h1',
  className = '',
  ...props
}: ComponentProps<'h1'> & {
  size?: PageTitleSize
  as?: 'h1' | 'h2'
}) {
  return <Tag className={`${pageTitleClass(size)} ${className}`} {...props} />
}
